// Debug logging utility for Song for the Mute cart system
// Toggle debug mode with: localStorage.setItem('SFTM_DEBUG', 'true')

const DEBUG_KEY = 'SFTM_DEBUG'
const DEBUG_PREFIX = '[SFTM Cart]'

export const isDebugMode = () => {
  if (typeof window === 'undefined') return false
  return localStorage.getItem(DEBUG_KEY) === 'true'
}

export const debugLog = (message, data = null) => {
  if (!isDebugMode()) return
  
  const timestamp = new Date().toISOString().substr(11, 12)
  const logMessage = `${DEBUG_PREFIX} ${timestamp} ${message}`
  
  if (data) {
    console.log(logMessage, data)
  } else {
    console.log(logMessage)
  }
}

export const debugError = (message, error = null) => {
  if (!isDebugMode()) return
  
  const timestamp = new Date().toISOString().substr(11, 12)
  const logMessage = `${DEBUG_PREFIX} ${timestamp} ERROR: ${message}`
  
  if (error) {
    console.error(logMessage, error)
  } else {
    console.error(logMessage)
  }
}

export const debugWarn = (message, data = null) => {
  if (!isDebugMode()) return
  
  const timestamp = new Date().toISOString().substr(11, 12)
  const logMessage = `${DEBUG_PREFIX} ${timestamp} WARN: ${message}`
  
  if (data) {
    console.warn(logMessage, data)
  } else {
    console.warn(logMessage)
  }
}

// Helper to enable/disable debug mode
export const setDebugMode = (enabled) => {
  if (typeof window === 'undefined') return
  
  if (enabled) {
    localStorage.setItem(DEBUG_KEY, 'true')
    console.log(`${DEBUG_PREFIX} Debug mode ENABLED. Use setDebugMode(false) to disable.`)
  } else {
    localStorage.removeItem(DEBUG_KEY)
    console.log(`${DEBUG_PREFIX} Debug mode DISABLED.`)
  }
}

// Export for global access in browser console
if (typeof window !== 'undefined') {
  window.sftmDebug = { setDebugMode, isDebugMode }
}